import { render, staticRenderFns } from "./NutritionWorkshopComp.vue?vue&type=template&id=3a2e435b&scoped=true"
import script from "./NutritionWorkshopComp.vue?vue&type=script&lang=js"
export * from "./NutritionWorkshopComp.vue?vue&type=script&lang=js"
import style0 from "./NutritionWorkshopComp.vue?vue&type=style&index=0&id=3a2e435b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e435b",
  null
  
)

/* custom blocks */
import block0 from "./NutritionWorkshopComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports